<template>
  <v-container
    id="products"
    tag="section"
  >
    <base-material-card
      color="indigo"
      icon="mdi-archive"
      inline
      class="px-5 py-3"
      top-actions
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Orders
        </div>
      </template>

      <template v-slot:top-actions>
        <v-btn
          class="px-2 ml-1"
          color="success"
          @click="gotoNew()"
        >
          New order
        </v-btn>
        <v-btn
          class="px-2 ml-1 v-btn--tight"
          color="info"
          @click="refreshOrders()"
        >
          Refresh
        </v-btn>
      </template>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Search"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="orders"
        :search.sync="search"
        :sort-desc="[false, false]"
        multi-sort
        class="row-action"
      >
        <template v-slot:item="{ item }">
          <tr @click="gotoDetails(item)">
            <td class="text-right">
              <v-btn
                class="px-2 ml-1"
                color="info"
                rounded
                small
                @click.stop="gotoDetails(item)"
              >
                Details
              </v-btn>
            </td>
            <td>{{ item.uid.substring(0, 7) }}</td>
            <td>{{ item.customerName }}</td>
            <td>{{ item.createDate | moment("DD/MM/YYYY HH:mm:ss") }}</td>
            <td class="text-right">
              <div v-show="item.totalAmount>0">
                <span class="mdi mdi-currency-eur" />{{ item.totalAmount.toFixed(2) }}
              </div>
              <div v-show="item.totalAmount===0">
                -
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data: () => ({
      headers: [
        {
          sortable: false,
          text: '',
          width: '1%',
        },
        {
          sortable: true,
          text: 'Id',
          value: 'uid',
        },
        {
          sortable: true,
          text: 'Customer',
          value: 'customerName',
        },
        {
          sortable: true,
          text: 'Order Date',
          value: 'createDate',
        },
        {
          sortable: true,
          text: 'Total Amount',
          value: 'totalAmount',
          align: 'end',
        },
      ],
      search: '',
    }),
    computed: {
      products () {
        return this.$store.state.products.list
      },
      orders () {
        return this.$store.state.orders.list.map(item => {
          return {
            ...item,
            customerName: this.getCustomerName(item.customerId),
          }
        })
      },
      ...mapGetters(['getCustomerName']),
    },
    created: async function () {
      // refresh the store if there are no items
      if (this.$store.state.orders.list.length === 0) {
        this.refreshOrders()
      }
    },
    methods: {
      async refreshOrders () {
        this.$store.dispatch('RefreshOrders')
      },
      gotoDetails (item) {
        this.$router.push({ name: 'Order', params: { uid: item.uid } })
      },
      gotoNew () {
        this.$router.push({ name: 'NewOrder' })
      },
    },
  }
</script>
